/**
 * Columns to omit from Stores page Excel export (flattened API keys).
 * Store hours come through as nested `StoreHours` fields in the payload.
 */
export function isStoresExcelExcludedColumn(columnKey: string): boolean {
  const compact = columnKey.toLowerCase().replace(/[\s_-]/g, '');
  return compact.includes('specialhours');
}

export function getStoresExcelColumnOrder(columnOrder: string[]): string[] {
  return columnOrder.filter(col => !isStoresExcelExcludedColumn(col));
}
